import React, { Component } from 'react'
import { Button, Skeleton } from 'antd'
import { connect } from 'react-redux'
import { injectIntl, FormattedMessage } from 'react-intl'
import { withRouter } from 'react-router'
import { toTitleCase } from '../../utils'
import './post.css'

export class Post extends Component {


  handleSubmit = (e) => {
    const { object } = this.props
    e.preventDefault()
    this.props.history.push(`/viewer/${object._id}`)
  }

  handleTitle = (value) => {
    if (value.length > 28) {
      return value.substring(0, 25) + '...'
    }
    return value
  }

  render() {
    const { object, isFetching } = this.props
    const { title, previewImage, description, category } = object
    return (
      <Skeleton loading={isFetching} active >
        <div className="masonry-item">
          <div className="masonry-content">
            <div className="post-container">
              <div>
                <img alt={title} className="post-image" src={previewImage} />
              </div>
              <div className="post-title">{title}</div>
              <div className="post-desc">{description}</div>
              <div className="post-button">
                <div>{toTitleCase(category)}</div>
                <div>
                  <Button type="primary" size="small" onClick={this.handleSubmit}>
                    <FormattedMessage id="post_see_more" />
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Skeleton>
    )
  }
}

const mapStateToProps = (state) => ({

})

const mapDispatchToProps = {

}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(Post)))
